import _pick from 'lodash/pick'
import { IncomingHttpHeaders } from 'http'
import { AxiosRequestConfig, AxiosRequestHeaders } from 'axios'
import { IRequestModel, RequestHandlerOptions } from './RequestModel.typed'
import { DEFAULT_METHOD, RequestMethod } from './RequestModel.consts'
import { envEnum, getEnv } from '../../../utils/crossEnv'
import { isServer } from '../../../utils'

export const prepareHeaders = (headers?: IncomingHttpHeaders): AxiosRequestHeaders => {
  const env = getEnv(envEnum.NEXT_PUBLIC_ENVIRONMENT)
  const headerNamesProd = ['x-user-id', 'x-host'] // for PROD and RC
  const headerNamesDev = ['x-guest-key', 'x-user-authenticated', 'x-user-id', 'x-host', 'cookie'] // for DEV

  const headerNames = env.startsWith('prod') || env.startsWith('rc') ? headerNamesProd : headerNamesDev

  return ((isServer && headers && _pick(headers, headerNames)) || {}) as AxiosRequestHeaders
}

const createRequestModel = ({ method = DEFAULT_METHOD, path }: IRequestModel) => {
  return <T>(params?: RequestHandlerOptions<T>): AxiosRequestConfig => {
    const { data = {}, options = {} } = params || {}

    return {
      method,
      url: path,
      params: method === 'GET' ? data : undefined,
      data: method !== 'GET' ? data : null,
      ...options,
    }
  }
}

export { createRequestModel, RequestMethod }
